export default class {
  items = []

  deleteItem = ([keyList]) => {
    this.items.filter(i => !keyList.includes(i.key))
  }

  addItem = (item) => {
    this.items.push(item)
  }

  dispose() {
    this.items = []
  }
  
  update(deltaTime) {
    this.items.forEach(item => {
      item.cb(deltaTime)
    })
  }
}